<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs" />
    </div>
    <div class="form-npa private-pg">
      <div class="position">
        <div class="bg-white p-20">
          <div class="form-head">
            <Widget position="menu_profile" />
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn dark v-on="on" class="navbar-toggler-profile">
                  {{ $t('Профиль') }} <span class="caret"></span>
                </v-btn>
              </template>
              <v-list class="navbar-collapse">
                <v-list-item>
                  <Widget position="menu_profile" />
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="form-body">
            <div class="private-section">
              <v-simple-table v-if="items.length">
                <thead>
                <tr>
                  <th v-for="(value, field) in tableFields" :key="field">
                    <template v-if="field !== 'offerVotes'">
                      <a @click="sortData(field)">
                        <i class="pro-icon-arrow-bottom1"></i>
                        {{ value }}
                      </a>
                    </template>
                    <template v-else>
                      {{ value }}
                    </template>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <router-link
                      :title="item.title"
                      active-class="active"
                      :to="$i18nRoute({
                        name: 'offer-view',
                        params: { id: item.id }
                      })"
                      :key="item.id"
                    >
                      {{ item.title }}
                    </router-link>
                  </td>
                  <td>
                    <div class="analytics">
                      <span class="views">
                        <i class="pro-icon-eye"></i>
                        {{ item.views ? item.views : 0 }}
                      </span>
                      <span class="comments">
                        <i class="pro-icon-like"></i>
                        {{ getProsCount(item.offer_votes) }}
                      </span>
                      <span class="messages">
                        <i class="pro-icon-dislike"></i>
                        {{ getConsCount(item.offer_votes) }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <span v-if="item.category">
                      {{ item.category.transName }}
                    </span>
                  </td>
                  <td>
                    {{ new Date(item.created_at) | dateFormat('DD.MM.YYYY') }}
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
              <div class="private-footer">
                <p>{{ $t("Общее количество") }}: {{ itemsTotal }}</p>
              </div>
              <v-pagination
                v-model="page"
                :length="pagesCount"
                :total-visible="10"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import { mapMutations } from 'vuex'
  import Widget from '@/components/app/Widget'
  import Offer from '@/model/offer'
  import {Trans} from "@/plugins/Translation"

  export default {
    components: {
      Widget
    },
    data: () => ({
      breadcrumbs: [],
      tableFields: {},
      items: [],
      sorting: {},
      sortSettings: {
        title: null,
        offerVotes: null,
        createdAt: null,
        category: null
      },
      itemsTotal: 0,
      page: 1,
      pagesCount: 1
    }),
    watch: {
      $route: 'fetchData',
      page() {
        this.fetchData()
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      ...mapMutations(['setLoading']),
      fetchData() {
        this.setLoading(true)
        this.sorting.page = this.page
        Offer.getUserOffers(this.sorting)
          .then((res) => {
            this.items = res.data.items
            const paginator = res.data.paginationData
            this.itemsTotal = paginator.totalCount
            this.pagesCount = paginator.pageCount
            this.breadcrumbs = [
              {
                text: this.$i18n.t('Профиль'),
                disabled: false,
                href: Trans.currentLocaleUrl + '/profile'
              },
              { text: this.$i18n.t('Все мои предложения'), disabled: true }
            ]
            this.tableFields = {
              title: this.$i18n.t('Наименование предложения'),
              offerVotes: this.$i18n.t('Голоса'),
              category: this.$i18n.t('Категории'),
              createdAt: this.$i18n.t('Дата')
            }
            this.setLoading(false)
          })
          .catch((err) => {
            this.$router.push(Trans.i18nRoute({
              name: 'error',
              params: {
                status: err.response.status
              }
            }))
            this.setLoading(false)
          })
      },
      sortData(sortKey) {
        if (
          !this.sortSettings[sortKey] ||
          this.sortSettings[sortKey] === 'desc'
        ) {
          this.sortSettings[sortKey] = 'asc'
        } else {
          this.sortSettings[sortKey] = 'desc'
        }

        this.page = 1

        this.sorting = {
          page: this.page,
          orderBy: sortKey,
          orderDir: this.sortSettings[sortKey]
        }
        this.fetchData()
      },
      getProsCount(arr) {
        return arr.filter((v) => v.voice_type.id === 1).length
      },
      getConsCount(arr) {
        return arr.filter((v) => v.voice_type.id === 2).length
      },
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>
